<template>
  <div class="w-100 mt5 f1 fw2 tc pa5-l pa3 pv4-l mv5-l">
    Are you lost?<div class="i mt5">404</div>
  </div>
</template>

<script>
export default {
  name: 'e404',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/e404.vue